import React, { useEffect, useState } from "react";
import classnames from "classnames";

import { updateFn } from "../shared/events";

const checkValue = (defaultValue, value, displayZero) => {
    const newValue = defaultValue || !isNaN(defaultValue) ? defaultValue : value;

    if (newValue === 0 && !displayZero) {
        return 0;
    }

    if (newValue === null || newValue === 0) {
        return "";
    }

    return newValue || !isNaN(newValue) ? newValue : "";
};

const NumberInput = (props) => {
    const [value, setValue] = useState(checkValue(props.defaultValue, props.value, props.displayZero));

    useEffect(() => {
        const newValue = checkValue(props.defaultValue, props.value);

        if (props.onValidatePair) {
            props.onValidatePair(newValue);
        }

        if (newValue.toString() !== value.toString()) {
            setValue(newValue);
        }
    }, [props.defaultValue, props.value]);

    const onChange = (e) => {
        setValue(e.currentTarget.value);

        if (props.onValidatePair) {
            props.onValidatePair(e.target.value);
        }

        if (props.onChange) {
            props.onChange(e);
        } else if (props.updateOnChange) {
            updateFn(props.updateOnChange)(e);
        }
    };

    return (
        <input
            type="number"
            inputMode={props.inputMode}
            key={`input_${props.id || props.name || ""}`}
            id={props.id || props.name || ""}
            name={props.name}
            autoComplete={props.autoComplete}
            max={props.max}
            min={props.min}
            multiple={props.multiple}
            pattern={props.pattern}
            placeholder={props.placeholder}
            readOnly={props.readOnly}
            required={props.required}
            step={props.step}
            value={value}
            onChange={onChange}
            onBlur={props.onBlur || updateFn(props.updateOnBlur)}
            onFocus={props.onFocus}
            className={classnames({ "-error": props.invalid })}
            disabled={props.disabled}
        />
    );
};

export default NumberInput;
